package com.devi3east.bashbuddy.cart.ui.components

import androidx.compose.foundation.LocalIndication
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.indication
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ElevatedCard
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Switch
import androidx.compose.material3.SwitchDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import coil3.compose.AsyncImage
import com.devi3east.bashbuddy.cart.domain.models.CartItem
import com.devi3east.bashbuddy.features.common.util.formatPrice
import com.devi3east.bashbuddy.features.events.common.data.models.TicketType
import com.devi3east.bashbuddy.features.events.detail.ui.components.QuantitySelector

@Composable
fun CartItemCard(
    cartItem: CartItem,
    onDelete: (ticketId: String) -> Unit,
    onUpdateQuantity: (ticketId: String, newQuantity: Int) -> Unit,
    onSetQuantity: (ticketId: String, quantity: Int) -> Unit,
    onSetShipping: (ticketId: String, selected: Boolean) -> Unit
) {
    val cardShape = RoundedCornerShape(16.dp)
    val interactionSource = remember { MutableInteractionSource() }

    ElevatedCard(
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = 8.dp)
            .clip(cardShape)
            .border(
                width = 1.dp,
                color = MaterialTheme.colorScheme.onBackground.copy(alpha = 0.1f),
                shape = cardShape
            )
            .indication(
                interactionSource = interactionSource,
                indication = LocalIndication.current
            )
            .clickable(
                interactionSource = interactionSource,
                indication = null,
                onClick = { }
            ),
        shape = cardShape,
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface),
        elevation = CardDefaults.elevatedCardElevation()
    ) {
        Column(modifier = Modifier.padding(16.dp)) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth()
            ) {
                AsyncImage(
                    model = cartItem.ticket.imageUrl ?: "",
                    contentDescription = cartItem.ticket.title,
                    contentScale = ContentScale.Crop,
                    modifier = Modifier
                        .size(80.dp)
                        .aspectRatio(1f)
                        .clip(RoundedCornerShape(12.dp))
                )

                Spacer(modifier = Modifier.width(16.dp))

                QuantitySelector(
                    quantity = cartItem.quantity,
                    onQuantityChange = { onUpdateQuantity(cartItem.ticket._id, it) },
                    onSetQuantity = { qty -> onSetQuantity(cartItem.ticket._id, qty) },
                    maxQuantity = cartItem.ticket.availableQuantity ?: 999
                )

                Spacer(modifier = Modifier.weight(1f))

                IconButton(onClick = { onDelete(cartItem.ticket._id) }) {
                    Icon(Icons.Default.Delete, contentDescription = "Delete Item")
                }
            }

            Spacer(modifier = Modifier.height(8.dp))

            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth()
            ) {
                Text(
                    text = formatPrice(cartItem.ticket.donation),
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.primary,
                    modifier = Modifier.weight(1f)
                )

                Spacer(modifier = Modifier.width(12.dp))

                Column(
                    modifier = Modifier.weight(4f)
                ) {
                    Text(
                        text = cartItem.ticket.title ?: "Ticket Title",
                        style = MaterialTheme.typography.titleMedium,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )

                    if (cartItem.ticket.ticketType == TicketType.PRINTED && !cartItem.ticket.serialNumber.isNullOrBlank()) {
                        Spacer(modifier = Modifier.height(4.dp))
                        Text(
                            text = "Serial #: ${cartItem.ticket.serialNumber}",
                            style = MaterialTheme.typography.bodySmall,
                            color = MaterialTheme.colorScheme.onSurfaceVariant
                        )
                    }
                }
            }
            if (cartItem.ticket.shippingFee > 0) {
                Spacer(modifier = Modifier.height(8.dp))

                var shippingChecked by remember { mutableStateOf(cartItem.shippingSelected) }

                Surface(
                    shape = RoundedCornerShape(12.dp),
                    tonalElevation = 1.dp,
                    modifier = Modifier.fillMaxWidth(),
                    color = MaterialTheme.colorScheme.surfaceVariant
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = 12.dp, vertical = 8.dp),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        Column {
                            Text(text = "Mail My Tickets", style = MaterialTheme.typography.bodyMedium)
                            Text(formatPrice(cartItem.ticket.shippingFee), style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.primary)
                        }

                        Switch(
                            checked = shippingChecked,
                            onCheckedChange = { checked ->
                                shippingChecked = checked
                                onSetShipping(cartItem.ticket._id, checked)
                            },
                            colors = SwitchDefaults.colors(
                                checkedThumbColor = MaterialTheme.colorScheme.primary,
                                uncheckedThumbColor = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.5f)
                            )
                        )
                    }
                }
            }

        }
    }
}